import { createSlice } from '@reduxjs/toolkit';
import axios from 'components/Axios';
import {
  insertJobPost,
  getOtherLocation,
  getjobpostId,
  jobApply,
  jobAlert,
  jobStatus,
  manageMessage,
} from 'redux/APIEndPoint';
import { Notification } from 'components/CustomNotification';
import { BaseUrl } from 'environment';

export const PostJobSlice = createSlice({
  name: 'dropdown',
  initialState: {
    locationList: [],
    jobPostList: [],
    jobDetailview: [],
    jobsubmit: [],
  },
  reducers: {
    location: (state, action) => {
      state.locationList = [action.payload];
    },
    joblist: (state, action) => {
      state.jobPostList = action.payload;
    },
    jobById: (state, action) => {
      state.jobDetailview = action.payload;
    },
    jobsubmit: (state, action) => {
      state.jobsubmit = action.payload;
    },
  },
});

export const addJobes = (payload, id, userId) => async () => {
  const Postid = '/' + id;
  const formData = new FormData();
  formData.set('userId', userId);
  formData.set('jobTitle', payload?.jobTitle);
  formData.set('yearOfExperience', payload?.yearOfExperience);
  // formData.set('categoryId', payload?.categoryId);
  formData.set('jobTypeIds', payload?.jobTypeIds);
  formData.set('workTypeIds', payload.workTypeIds);
  formData.set('salary', payload.salary);
  formData.set('location', JSON.stringify(payload.location));
  formData.set('jobDescription', payload.jobDescription);
  formData.set('link', payload.link);
  formData.set('preTemplate', payload.preTemplate);
  formData.set('companyName', payload.companyName);
  formData.set('companySize', payload.companySize);
  formData.set('companyWebsite', payload.companyWebsite);
  formData.set('companyDescription', payload.companyDescription);
  formData.append(
    'template',
    payload.template ? JSON.stringify(payload.template) : []
  );
  formData.append('companyLogo', payload.companyLogo[0] || '');
  formData.append('attachment', JSON.stringify(payload.attachment?.length > 0 ? payload.attachment : []));

  return await axios[id ? 'put' : 'post'](
    `${id ? insertJobPost + Postid : insertJobPost}`,
    formData
  );
};

export const getLocationList = () => async (dispatch) => {
  try {
    const response = await axios.get(getOtherLocation);
    dispatch(location(response.data?.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getJobPostList = (payload) => async (dispatch) => {
  return axios.get(`${BaseUrl}/${payload.url}`).then((response) => {
    dispatch(joblist(response?.data?.data));
    return response.data.data;
  });
};

export const getJobPostById = (id) => async (dispatch) => {
  return await axios
    .get(`${getjobpostId + id}?clientOffSet=${new Date().getTimezoneOffset()}`)
    .then((response) => {
      dispatch(jobById(response?.data?.data));
      return response.data.data;
    })
    .catch((err) => {
      console.warn(err.response?.data?.message);
      return err.response?.data;
    });
};

export const JobDelete = (data) => async () => {
  return axios
    .delete(`${BaseUrl}/jobPost`, {
        data 
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
      return err.response?.data;
    });
};

export const JobApply = (payload) => async () => {
  return await axios.post(jobApply, payload);
};

export const JobApplyList = (JobId, page, loadSize) => async () => {
  return await axios.get(
    `${jobApply}/jobId/${JobId}?page=${page || 0}&size=${loadSize || 15}`
  );
};

export const GetJobStatus = (payload, page, loadSize) => async () => {
  return await axios.get(
    `${jobStatus}/${payload?.id}/${payload?.status}?page=${page || 0}&size=${
      loadSize || 15
    }`
  );
};

export const UpdateJobStatus = (payload) => async () => {
  return await axios.put(jobStatus, payload);
};

// User Job Submitted List
export const getUserJobSubmittedList = (page, loadSize) => async () => {
  return await axios.get(
    `${jobApply}?page=${page || 0}&size=${loadSize || 15}`
  );
};

// Manage Message
export const saveManageMessage = (params) => async () => {
  return await axios.put(manageMessage, params);
};

export const getManageMessage = () => async () => {
  return await axios.get(manageMessage);
};

// Alert
export const JobAlertPost = (payload) => async () => {
  return axios.post(jobAlert, payload);
};

export const JobAlertUpdate = (payload, id) => async () => {
  return axios.put(`${jobAlert + '/' + id}`, payload);
};

export const GetAllJobAlert = () => async () => {
  return axios.get(jobAlert);
};

export const deleteJobAlertById = (id) => async () => {
  return axios.delete(`${jobAlert + '/' + id}`);
};

export const { location, joblist, jobById, jobsubmit } = PostJobSlice.actions;
export default PostJobSlice.reducer;
